import React, { useEffect, useState, useRef } from 'react';
import { QualifiedBanner } from './components/QualifiedBanner';
import { DebtQuestion } from './components/DebtQuestion';
import { TrustpilotRating } from './components/TrustpilotRating';
import { SecurityBadges } from './components/SecurityBadges';
import { Footer } from './components/Footer';
import { PrivacyPolicyModal } from './components/PrivacyPolicyModal';
import { TermsOfUseModal } from './components/TermsOfUseModal';
import { ExitIntentModal } from './components/ExitIntentModal';
export function App() {
  const [answer, setAnswer] = useState<'yes' | 'no' | null>(null);
  const [privacyOpen, setPrivacyOpen] = useState(false);
  const [termsOpen, setTermsOpen] = useState(false);
  const [exitOpen, setExitOpen] = useState(false);
  const exitShownRef = useRef(false);
  // Exit intent detection: trigger when the cursor moves out from the top of the viewport
  useEffect(() => {
    const handleMouseLeave = (e: MouseEvent) => {
      if (exitShownRef.current) return;
      if (e.clientY <= 0) {
        exitShownRef.current = true;
        setExitOpen(true);
      }
    };
    document.addEventListener('mouseleave', handleMouseLeave);
    return () => document.removeEventListener('mouseleave', handleMouseLeave);
  }, []);
  return <div className="flex flex-col min-h-screen w-full bg-white" data-id="element-0">
      <QualifiedBanner data-id="element-1" />

      <main className="flex-1 flex flex-col" data-id="element-2">
        <DebtQuestion onAnswer={setAnswer} data-id="element-3" />

        {answer && <div className="text-center text-sm text-gray-500 -mt-4 mb-2" role="status" aria-live="polite" data-id="element-4">
            You answered:{' '}
            <span className="font-semibold uppercase" data-id="element-5">{answer}</span>
          </div>}

        <TrustpilotRating data-id="element-6" />

        <div className="w-full max-w-3xl mx-auto flex flex-col items-center" data-id="element-7">
          <SecurityBadges data-id="element-8" />
          <Footer onOpenPrivacy={() => setPrivacyOpen(true)} onOpenTerms={() => setTermsOpen(true)} data-id="element-9" />
        </div>
      </main>

      <PrivacyPolicyModal open={privacyOpen} onClose={() => setPrivacyOpen(false)} data-id="element-10" />
      <TermsOfUseModal open={termsOpen} onClose={() => setTermsOpen(false)} data-id="element-11" />
      <ExitIntentModal open={exitOpen} onClose={() => setExitOpen(false)} data-id="element-12" />
    </div>;
}